import { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import DateRangePicker from "../DateRangePicker";
import { SideDrawer } from "../../../component/SideDrawer/SideDrawer"; // adjust path

export default function MyLineChart({ purchage, setStartDate, setEndDate }) {

  const groupedData = purchage.reduce((acc, item) => {
    const date = new Date(item.createdAt).toISOString().split("T")[0];
    const total = parseFloat(item.total) || 0;

    if (!acc[date]) {
      acc[date] = 0;
    }
    acc[date] += total;
    return acc;
  }, {});

  const sortedData = Object.entries(groupedData)
    .map(([date, total]) => ({
      name: date,
      PO: total,
    }))
    .sort((a, b) => new Date(b.name) - new Date(a.name));

  const pieData = sortedData.slice(0, 5);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <div style={{ width: "100%", height: 320 }} className="bg-white p-5">
      <div className="flex flex-row justify-between items-center">
        <h5 className="md:text-[20px] text-[20px] font-bold text-gray-800 mb-4">
          Days wise Purchase Orders Cost
        </h5>
        {/* <Filter
          className="cursor-pointer"
          onClick={() => setIsDrawerOpen(true)}
        /> */}
      </div>

      <ResponsiveContainer>
        <LineChart
          data={pieData}
          margin={{ top: 20, right: 10, left: 0, bottom: 40 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis
            tickFormatter={(value) => {
              if (value >= 1000000) return (value / 1000000).toFixed(1) + "M"; // 1M
              if (value >= 1000) return (value / 1000).toFixed(1) + "k";       // 1k
              return value;
            }}
          />

          <Tooltip
            formatter={(value) =>
              new Intl.NumberFormat("en-IN", {
                style: "currency",
                currency: "INR",
                maximumFractionDigits: 0,
              }).format(value)
            }
          />

          <Legend
            content={({ payload }) => (
              <div className="flex flex-wrap justify-center items-center mt-2 w-full px-2 bg-white md:mb-0 mb-10">
                {payload.map((entry, index) => (
                  <div
                    key={`legend-${index}`}
                    className="flex items-center mx-2 my-1 text-xs sm:text-sm"
                  >
                    <span
                      className="w-3 h-3 inline-block mr-2 rounded"
                      style={{ backgroundColor: entry.color }}
                    />
                    <span className="truncate max-w-[80px] sm:max-w-none">
                      {entry.value}
                    </span>
                  </div>
                ))}
              </div>
            )}
          />

          <Line
            type="monotone"
            dataKey="PO"
            stroke="#8884d8"
            activeDot={{ r: 8 }}
          />
        </LineChart>
      </ResponsiveContainer>

      <SideDrawer
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        title="Filter Options"
        customWidth
      >
        <div className="px-12">
          <DateRangePicker
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setIsDrawerOpen={setIsDrawerOpen}
          />
        </div>
      </SideDrawer>
    </div>
  );
}
